import * as React from "react";
import TextField from "@mui/material/TextField";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import { prefixer } from "stylis";
import rtlPlugin from "stylis-plugin-rtl";
import persian_fa from "react-date-object/locales/persian_fa";
import DatePicker, { DateObject } from "react-multi-date-picker";
import { FormControl } from "@mui/material";
import { styled } from "@mui/material/styles";
import { isNull } from "lodash";
import Toolbar from "react-multi-date-picker/plugins/toolbar";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import calendar from "react-date-object/calendars/jalali";
import persian from "react-date-object/calendars/persian";

const cacheRtl = createCache({
  key: "muirtl",
  stylisPlugins: [prefixer, rtlPlugin],
});

interface DatePickerCmpPropsInterface {
  onChange: Function;
  value?: Date | null;
  error?: boolean;
  helperText?: string;
  label?: string;
  range: boolean;
  valueArray?: Date[] | null;
}

let mainColor: any;

export default function DatePickerComponents({
  onChange,
  value,
  error = false,
  helperText = "",
  label = "",
  range,
  valueArray,
}: DatePickerCmpPropsInterface) {
  function handleOnChange(newValue: any) {
    onChange(newValue);
  }
  const [val, setVal] = React.useState(value);
  let dateYear = valueArray
    ? new Date(valueArray[0])
        .toLocaleDateString("fa-IR-u-ca-persian")
        .split("/")[0]
    : new Date(value ?? new Date())
        .toLocaleDateString("fa-IR-u-ca-persian")
        .split("/")[0];
  return (
    <div style={{ display: "block" }}>
      <DatePicker
        render={<CustomComponent label={label} error={error} value={val} />}
        inputClass="form-control"
        value={valueArray != undefined ? valueArray : value}
        className="datePicker"
        calendar={dateYear === "۱۴۰۴" ? persian : calendar}
        onYearChange={(date: any) => {
          handleOnChange(date);
        }}
        onChange={(newValue: any) => {
          handleOnChange(newValue as Date);
        }}
        locale={persian_fa}
        calendarPosition="bottom-center"
        plugins={[<Toolbar position="bottom" />]}
        // numberOfMonths={2}
        // multiple
        range={range}
        dateSeparator=" - "
      ></DatePicker>
    </div>
  );
}

const CustomComponent = (props: any) => {
  const jsonFile = useSelector((state: any) => state.style);

  mainColor = jsonFile?.mainColor;
  const CssTextField = styled(TextField)({
    "& label.Mui-focused": {
      color: mainColor,
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: mainColor,
    },
    "& .MuiOutlinedInput-root": {
      "&.Mui-focused fieldset": {
        borderColor: mainColor,
      },
    },
  });
  return (
    <CacheProvider value={cacheRtl}>
      <FormControl fullWidth>
        <CssTextField
          value={props.value}
          onClick={props.openCalendar}
          onChange={props.onChange}
          label={props.label}
          error={props.error}
          id="custom-css-outlined-input"
          autoComplete="off"
        />
      </FormControl>
    </CacheProvider>
  );
};
